/* o3.js — Ondessa™ Pulse PDP v2 behaviours. Loaded (deferred) by every o3 section;
   guarded so it runs once. Every module is progressive: the markup works without JS
   (native form posts to /cart/add, <details> open natively, tabs fall back to first panel). */
(function () {
  if (window.__o3) return;
  window.__o3 = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + (v.slice(-3) === '.00' ? v.slice(0, -3) : v);
  };

  /* ---------- reveal + count-up ---------- */
  function reveal(root) {
    var els = $$('.o3-rv:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); countAll(root); return; }
    $$('[data-o3-count]', root).forEach(function (c) { if (!c.__done && c.firstChild) c.firstChild.nodeValue = '0'; });
    var show = function (el) {
      el.classList.add('is-in');
      $$('[data-o3-count]', el).forEach(count);
      if (el.hasAttribute('data-o3-count')) count(el);
      io.unobserve(el);
    };
    // a card inside a swipe row reveals its whole row: otherwise the cards past the edge stay
    // transparent until swiped in, and the swipe lands on an empty slot before they fade up
    var row = function (el) {
      for (var p = el.parentElement, i = 0; p && i < 3; p = p.parentElement, i++) {
        if (p.scrollWidth > p.clientWidth + 2 && /auto|scroll/.test(getComputedStyle(p).overflowX)) return p;
      }
      return null;
    };
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        show(x.target);
        var r = row(x.target);
        if (r) $$('.o3-rv:not(.is-in)', r).forEach(show);
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0.01 });
    els.forEach(function (e) { io.observe(e); });
  }
  function count(el) {
    if (el.__done) return; el.__done = true;
    var to = parseFloat(el.getAttribute('data-o3-count')); if (isNaN(to)) return;
    if (reduce) { el.firstChild.nodeValue = String(to); return; }
    var t0 = null, dur = 1100;
    var step = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.firstChild.nodeValue = String(Math.round(to * e));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  function countAll(root) { $$('[data-o3-count]', root).forEach(count); }

  /* ---------- gallery ---------- */
  function gallery(root) {
    $$('[data-o3-gallery]', root).forEach(function (g) {
      if (g.__o3) return; g.__o3 = 1;
      var track = $('.o3-gal__track', g), slides = $$('.o3-gal__slide', g);
      var thumbs = $$('.o3-gal__thumb', g), dots = $$('.o3-gal__dot', g);
      var cur = 0;
      var set = function (i, scroll) {
        cur = (i + slides.length) % slides.length;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
        if (thumbs[cur]) {
          var box = thumbs[cur].parentNode, tl = thumbs[cur].offsetLeft, tw = thumbs[cur].offsetWidth;
          if (tl < box.scrollLeft || tl + tw > box.scrollLeft + box.clientWidth) box.scrollLeft = tl - (box.clientWidth - tw) / 2;
        }
        if (scroll) track.scrollTo({ left: slides[cur].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      };
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { set(k, true); }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { set(k, true); }); });
      var prev = $('[data-o3-prev]', g), next = $('[data-o3-next]', g);
      if (prev) prev.addEventListener('click', function () { set(cur - 1, true); });
      if (next) next.addEventListener('click', function () { set(cur + 1, true); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== cur) set(i, false);
        });
      }, { passive: true });
      g.__o3set = set;
    });
  }

  /* ---------- buy form (tiers + ATC → cart → checkout) ---------- */
  // extra: variant ids that ride along as a bundle (one each, tagged with a hidden line property); one request, so the
  // belt and its gifts land in the cart together or not at all
  function addAndCheckout(id, qty, btn, errEl, extra) {
    var lab = btn && btn.querySelector('span'), was = lab && lab.innerHTML;
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    if (lab) lab.textContent = 'Preparing your checkout…';
    var want = [{ id: Number(id), quantity: qty || 1 }];
    (extra || []).forEach(function (x) { want.push({ id: Number(x), quantity: 1, properties: { _bundle: 'Ondessa Pulse bundle' } }); });
    // A second click (Back from checkout, a double tap) must not stack a second belt and two more bottles: the gift discount covers
    // one bundle per order, so the extra bottles would be charged (07-10). Add only what the cart does not hold yet, then check out.
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : {}; }, function () { return {}; })
      .then(function (cart) {
        var have = {};
        (cart.items || []).forEach(function (i) { have[i.variant_id] = true; });
        var items = want.filter(function (w) { return !have[w.id]; });
        if (!items.length) return;
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
        });
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function (e) {
        if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); }
        if (lab) lab.innerHTML = was;
        if (errEl) { errEl.textContent = e.message.replace(/\.?\s*$/, '.') + ' Please try again.'; errEl.classList.add('is-on'); }
      });
  }

  function buyForms(root) {
    $$('[data-o3-buy]', root).forEach(function (f) {
      if (f.__o3) return; f.__o3 = 1;
      var data = {};
      try { data = JSON.parse($('script[data-o3-variants]', f.closest('.o3')).textContent); } catch (e) {}
      var btnLabel = $('[data-o3-atc-price]', f), err = $('.o3-atc__err', f), btn = $('button[type="submit"]', f);
      var anchor = $('[data-o3-anchor]', f);
      var stk = document.querySelector('[data-o3-sticky]');
      var fixed = f.hasAttribute('data-o3-fixed'); // claim card: Liquid rendered the bundle's value/savings, keep them
      var sync = function () {
        var input = $('input[name="id"]:checked', f) || $('input[name="id"]', f); if (!input) return;
        $$('.o3-tier', f).forEach(function (l) { l.classList.toggle('is-on', l.contains(input)); });
        var v = data[input.value]; if (!v) return;
        if (btnLabel) btnLabel.textContent = money(v.price);
        if (fixed) return;
        if (anchor) anchor.innerHTML = (v.compare > v.price ? '<s>' + money(v.compare) + '</s><span class="o3-offer__arrow" aria-hidden="true">→</span>' : '') + '<b>' + money(v.price) + '</b>';
        if (stk) {
          var p = $('[data-o3-stk-price]', stk);
          if (p) p.innerHTML = money(v.price) + (v.compare > v.price ? '<s>' + money(v.compare) + '</s><em>Save ' + money(v.compare - v.price) + '</em>' : '');
          var n = $('[data-o3-stk-name]', stk); if (n && v.label) n.textContent = v.label;
        }
      };
      $$('input[name="id"]', f).forEach(function (i) { i.addEventListener('change', sync); });
      sync();
      f.addEventListener('submit', function (e) {
        var input = $('input[name="id"]:checked', f) || $('input[name="id"]', f);
        if (!input || !window.fetch) return;
        e.preventDefault();
        if (err) err.classList.remove('is-on');
        addAndCheckout(input.value, 1, btn, err, $$('[data-o3-bundle-id]', f).map(function (i) { return i.value; }));
      });
    });
    $$('[data-o3-add]', root).forEach(function (b) {
      if (b.__o3) return; b.__o3 = 1;
      b.addEventListener('click', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        addAndCheckout(b.getAttribute('data-o3-add'), 1, b, null);
      });
    });
  }

  /* ---------- claim card: Pulse / Light / Both demo + one tick-in of the box contents ---------- */
  /* ---------- delivery estimate: today + N business days (the page's own shipping line) ---------- */
  function eta(root) {
    $$('[data-o3-eta]', root).forEach(function (el) {
      if (el.__o3) return; el.__o3 = 1;
      var a = parseInt(el.getAttribute('data-min'), 10) || 4, b = parseInt(el.getAttribute('data-max'), 10) || 9;
      var add = function (n) { var d = new Date(), k = 0; while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k += 1; } return d; };
      var f = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
      el.textContent = (el.getAttribute('data-label') || 'Estimated delivery') + ': ' + f(add(a)) + ' – ' + f(add(b));
      el.hidden = false;
    });
  }

  function claim(root) {
    $$('[data-o3-claim]', root).forEach(function (c) {
      if (c.__o3) return; c.__o3 = 1;
      var viz = $('[data-o3-viz]', c), cap = $('[data-o3-cap]', c), btns = $$('[data-o3-mode]', c);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var touched = false, timer = 0;
      var set = function (m) {
        if (!viz) return;
        viz.setAttribute('data-mode', m);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-o3-mode') === m ? 'true' : 'false'); });
        var on = btns.filter(function (b) { return b.getAttribute('data-o3-mode') === m; })[0];
        if (cap && on && on.getAttribute('data-cap')) cap.textContent = on.getAttribute('data-cap');
      };
      btns.forEach(function (b) {
        // the caption is announced only once the shopper has tapped — the guided pass must not talk over a screen reader
        b.addEventListener('click', function () { touched = true; clearTimeout(timer); if (cap) cap.setAttribute('aria-live', 'polite'); set(b.getAttribute('data-o3-mode')); });
      });
      if (!reduce) c.classList.add('is-armed');
      var start = function () {
        c.classList.add('is-live');
        if (reduce || touched) return;
        // one guided pass — the pulse alone, the light alone, then both — and it rests; any tap ends it
        var seq = ['pulse', 'light', 'both'], k = 0;
        var step = function () { if (touched) return; set(seq[k]); k += 1; if (k < seq.length) timer = setTimeout(step, 2300); };
        timer = setTimeout(step, 1100);
      };
      if (!('IntersectionObserver' in window)) { start(); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!c.classList.contains('is-live')) start(); c.classList.remove('is-paused'); }
          else c.classList.add('is-paused'); // the ring loop stops while the card is off screen
        });
      }, { threshold: 0.2 }).observe(c);
    });
  }

  /* ---------- cart drawer: app refreshes must not pop it open ---------- */
  // The theme's cart-drawer.renderContents() always opens the drawer. Apps that touch the cart call it after their own cart calls:
  // 07-10 the Cart Bot app retries a dead rule every few seconds once the cart holds anything (POST /cart/add 422, then
  // renderContents), so a shopper back from checkout had the drawer popping open again and again over the page and the Claim
  // button. On this page the buy button goes straight to checkout and never needs the drawer: a refresh updates its contents and
  // leaves it as it was (open stays open, closed stays closed). The cart icon still opens it (that path calls open() directly).
  function quietDrawer() {
    if (!window.customElements) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var d = document.querySelector('cart-drawer');
      if (!d || d.__o3quiet || typeof d.renderContents !== 'function') return;
      d.__o3quiet = 1;
      var render = d.renderContents;
      d.renderContents = function () {
        var self = this, keep = this.classList.contains('active'), open = this.open;
        // renderContents opens through a setTimeout it queues itself; ours is queued after it, so it runs after that open()
        this.open = function () { if (keep) return open.apply(self, arguments); };
        try { return render.apply(this, arguments); } finally { setTimeout(function () { delete self.open; }, 0); }
      };
    });
  }

  /* ---------- sticky ATC ---------- */
  function sticky() {
    var s = document.querySelector('[data-o3-sticky]'); if (!s || s.__o3) return; s.__o3 = 1;
    var target = document.querySelector('[data-o3-buy] button[type="submit"]');
    var btn = $('button', s);
    if (btn) btn.addEventListener('click', function () {
      var f = document.querySelector('[data-o3-buy]');
      if (f && f.requestSubmit) f.requestSubmit(); else if (f) f.submit();
    });
    if (!target) return;
    // measured on every scroll frame, not with IntersectionObserver: a jump from below the buy
    // button straight back to the top never crosses the viewport, so no observer callback fires
    // and the bar stayed up over the first screen (caught by qa.mjs 28-09)
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    var on = null, raf = 0;
    var apply = function () {
      raf = 0;
      var want = target.getBoundingClientRect().bottom < 0 && !(footer && footer.getBoundingClientRect().top < window.innerHeight);
      if (want === on) return;
      on = want;
      s.classList.toggle('is-on', want);
      s.setAttribute('aria-hidden', want ? 'false' : 'true');
    };
    var req = function () { if (!raf) raf = requestAnimationFrame(apply); };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    apply();
  }

  /* ---------- generic tabs (story + specs) ---------- */
  function tabs(root) {
    $$('[data-o3-tabs]', root).forEach(function (w) {
      if (w.__o3) return; w.__o3 = 1;
      var btns = $$('[role="tab"]', w), panels = $$('[role="tabpanel"]', w), imgs = $$('[data-o3-tabimg]', w);
      var cur = 0, auto = w.hasAttribute('data-o3-auto') && !reduce, timer;
      var set = function (i, focus) {
        cur = (i + btns.length) % btns.length;
        btns.forEach(function (b, k) { var on = k === cur; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on && focus) b.focus(); });
        panels.forEach(function (p, k) { var on = k === cur; p.classList.toggle('is-on', on); if (p.hasAttribute('data-hide')) p.hidden = !on; });
        imgs.forEach(function (m, k) { m.classList.toggle('is-on', k === cur); });
        if (btns[cur] && btns[cur].scrollIntoView && btns[cur].parentNode.scrollWidth > btns[cur].parentNode.clientWidth) {
          var bar = btns[cur].parentNode; bar.scrollLeft = btns[cur].offsetLeft - (bar.clientWidth - btns[cur].offsetWidth) / 2;
        }
      };
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () { stop(); set(k); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); stop(); set(cur + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); set(cur - 1, true); }
        });
      });
      var p = $('[data-o3-tprev]', w), n = $('[data-o3-tnext]', w);
      if (p) p.addEventListener('click', function () { stop(); set(cur - 1); });
      if (n) n.addEventListener('click', function () { stop(); set(cur + 1); });
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (auto && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting && !timer) timer = setInterval(function () { set(cur + 1); }, 6000);
            if (!x.isIntersecting) stop();
          });
        }, { threshold: 0.4 }).observe(w);
        w.addEventListener('pointerdown', stop, { once: true });
      }
      set(0);
    });
  }

  /* ---------- duo expandable cards + slider nav ---------- */
  function duo(root) {
    $$('.o3-duo__card', root).forEach(function (c) {
      if (c.__o3) return; c.__o3 = 1;
      var t = $('.o3-duo__tog', c);
      if (t) t.addEventListener('click', function () {
        var open = c.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    $$('[data-o3-slider]', root).forEach(function (w) {
      if (w.__o3) return; w.__o3 = 1;
      var tr = $('[data-o3-track]', w);
      var go = function (dir) { tr.scrollBy({ left: dir * tr.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); };
      var p = $('[data-o3-sprev]', w), n = $('[data-o3-snext]', w);
      if (p) p.addEventListener('click', function () { go(-1); });
      if (n) n.addEventListener('click', function () { go(1); });
    });
  }

  /* ---------- details carousel with ring progress (ref page9) ---------- */
  function details(root) {
    $$('[data-o3-details]', root).forEach(function (w) {
      if (w.__o3) return; w.__o3 = 1;
      var slides = $$('.o3-dt__slide', w), imgs = $$('.o3-dt__img', w), ths = $$('.o3-dt__th', w);
      var name = $('.o3-dt__name', w), role = $('.o3-dt__role', w);
      var ms = parseInt(w.getAttribute('data-ms') || '5200', 10), cur = 0, timer = null, vis = false;
      w.style.setProperty('--o3-dt-ms', ms + 'ms');
      var set = function (i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
        imgs.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
        ths.forEach(function (t, k) {
          t.classList.remove('is-on'); void t.offsetWidth;
          if (k === cur) t.classList.add('is-on');
          t.setAttribute('aria-pressed', k === cur ? 'true' : 'false');
        });
        if (name && ths[cur]) name.textContent = ths[cur].getAttribute('data-name') || '';
        if (role && ths[cur]) role.textContent = ths[cur].getAttribute('data-role') || '';
      };
      var play = function () { if (reduce || timer) return; timer = setInterval(function () { if (!w.classList.contains('is-paused')) set(cur + 1); }, ms); };
      var stop = function () { clearInterval(timer); timer = null; };
      ths.forEach(function (t, k) { t.addEventListener('click', function () { stop(); set(k); if (vis) play(); }); });
      w.addEventListener('mouseenter', function () { w.classList.add('is-paused'); });
      w.addEventListener('mouseleave', function () { w.classList.remove('is-paused'); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { en.forEach(function (x) { vis = x.isIntersecting; if (vis) play(); else stop(); }); }, { threshold: 0.3 }).observe(w);
      }
      set(0);
    });
  }

  /* ---------- steps coverflow (ref page11) ---------- */
  function steps(root) {
    $$('[data-o3-steps]', root).forEach(function (w) {
      if (w.__o3) return; w.__o3 = 1;
      var cards = $$('.o3-hw__card', w), dots = $$('.o3-hw__dot', w), cur = 0;
      var mobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
      var set = function (i) {
        cur = Math.max(0, Math.min(cards.length - 1, i));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); d.setAttribute('aria-current', k === cur ? 'step' : 'false'); });
        if (mobile()) return;
        cards.forEach(function (c, k) {
          var d = k - cur, ad = Math.abs(d);
          c.style.transform = 'translateX(' + (d * 250) + 'px) translateZ(' + (-ad * 140) + 'px) rotateY(' + (d * -18) + 'deg)';
          c.style.opacity = ad > 2 ? '0' : String(1 - ad * 0.22);
          c.style.zIndex = String(10 - ad);
          c.style.filter = ad ? 'saturate(.75)' : 'none';
          c.setAttribute('aria-hidden', ad > 0 ? 'true' : 'false');
        });
      };
      dots.forEach(function (d, k) { d.addEventListener('click', function () { set(k); var st = $('.o3-hw__stage', w); if (mobile() && cards[k]) st.scrollTo({ left: cards[k].offsetLeft - 20, behavior: 'smooth' }); }); });
      var p = $('[data-o3-hprev]', w), n = $('[data-o3-hnext]', w);
      if (p) p.addEventListener('click', function () { set(cur - 1); });
      if (n) n.addEventListener('click', function () { set(cur + 1); });
      cards.forEach(function (c, k) { c.addEventListener('click', function () { if (!mobile() && k !== cur) set(k); }); });
      var stage = $('.o3-hw__stage', w), raf;
      stage.addEventListener('scroll', function () {
        if (!mobile()) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var best = 0, bd = 1e9, mid = stage.scrollLeft + stage.clientWidth / 2;
          cards.forEach(function (c, k) { var cm = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(cm - mid); if (dd < bd) { bd = dd; best = k; } });
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === best); });
        });
      }, { passive: true });
      window.addEventListener('resize', function () { set(cur); });
      set(0);
    });
  }

  /* ---------- moments show-more, FAQ filter ---------- */
  function misc(root) {
    $$('[data-o3-more]', root).forEach(function (b) {
      if (b.__o3) return; b.__o3 = 1;
      b.addEventListener('click', function () { var s = b.closest('.o3-mo'); if (s) s.classList.add('is-all'); });
    });
    $$('[data-o3-filter]', root).forEach(function (w) {
      if (w.__o3) return; w.__o3 = 1;
      var pills = $$('[data-topic]', w), groups = $$('[data-group]', w.closest('.o3'));
      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          var t = p.getAttribute('data-topic');
          pills.forEach(function (q) { q.setAttribute('aria-pressed', q === p ? 'true' : 'false'); });
          groups.forEach(function (g) { g.hidden = !(t === 'all' || g.getAttribute('data-group') === t); });
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    reveal(root); gallery(root); buyForms(root); eta(root); claim(root); tabs(root); duo(root); details(root); steps(root); misc(root); sticky(); quietDrawer();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
